// validate user credentials

const J2VAuth = {};

J2VAuth.baseURL = "https://api.json2video.com/v2";

J2VAuth.login = async function () {
    try {
        const userCredentials = this.getCredentials();
        if (!userCredentials) {
            console.log("No user credentials");
            return {
                success: false,
                message: "No user credentials"
            };
        }
        
        var user = await this.sendGetRequestWithHeader(
            `${J2VAuth.baseURL}/account`, 
            userCredentials.headerName, 
            userCredentials.headerValue);
    }
    catch (error) {
        this.logout();
        return {
            success: false,
            message: "Credentials could not be validated"
        };
    }

    if (user.success === true) {
        // const credentials = {
        //     email: email,
        //     apiKey: apikey
        // };
        // localStorage.setItem("userCredentials", JSON.stringify(credentials));
        // localStorage.setItem("userProfile", JSON.stringify({
        //     firstName: user.user?.first_name ?? null,
        //     lastName: user.user?.last_name ?? null,
        //     picture: user.user?.picture ?? null,
        //     plan: user.account?.plan ?? null,
        //     planInfo: user.account?.plan_info ?? null,
        //     quota: user.remaining_quota  ?? null
        // }));
        return {
            success: true,
            message: "Credentials validated",
            data: user
        };
    }
    else {
        this.logout();
        return {
            success: false,
            message: "There was a problem signing in"
        };
    }
};

J2VAuth.logout = function () {
    localStorage.removeItem("userCredentials");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("userSession");
};

J2VAuth.isSignedIn = function () {
    const apiCredentials = localStorage.getItem("userAPIKey");
    if (apiCredentials) return true;
    
    const sessionCredentials = localStorage.getItem("userSession");
    if (sessionCredentials) return true;

    return false;
};

J2VAuth.getUserProfile = function () {
    const userProfile = localStorage.getItem("userProfile");
    if (userProfile) {
        return JSON.parse(userProfile);
    }
    return null;
};

J2VAuth.getCredentials = function () {
    const userAPIKey = localStorage.getItem("userAPIKey");
    const userSession = localStorage.getItem("userSession");

    if (userSession) return { headerName: "x-session-id", headerValue: userSession };
    if (userAPIKey) return { headerName: "x-api-key", headerValue: userAPIKey };

    return null;
}

J2VAuth.refresh = async function () {
    const storedCredentials = localStorage.getItem("userCredentials");
    if (storedCredentials) {
        const credentials = JSON.parse(storedCredentials);
        if (!credentials) return false;

        return await this.login(credentials.email, credentials.apiKey);
    }

    const userSession = localStorage.getItem("userSession");
    if (userSession) {
        return await this.login(null, userSession);
    }

    return false;
};

J2VAuth.redirectToLoginScreen = function () {
    window.location.href = "/login";
};

J2VAuth.sendGetRequestWithHeader = async function (url, headerName, headerValue) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.setRequestHeader(headerName, headerValue);

        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response);
                } else {
                    reject('Error: ' + xhr.status);
                }
            }
        };

        xhr.send();
    });
}

export default J2VAuth;